import axios from 'axios';
import Url from '../constants/Url';

class InfluencerApi {
    getInfluencerProfile() {
        return axios
            .get(Url().GET_INFLUENCER_PROFILE)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to get influencer profile:', ex.message);
                throw ex;
            });
    }

    createInfluencerProfile(data?) {
        return axios
            .post(Url().CREATE_INFLUENCER_PROFILE, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to create influencer profile:', ex.message);
                throw ex;
            });
    }

    reactivateInfluencerProfile(data?) {
        return axios
            .post(Url().REACTIVATE_INFLUENCER_PROFILE, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to update influencer profile:', ex.message);
                throw ex;
            });
    }

    resendEmailVerification() {
        return axios
            .post(Url().CREATE_RESEND_EMAIL_VERIFICATION, {})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to resend email verification:', ex.message);
                throw ex;
            });
    }

    getSocialChannels() {
        return axios
            .get(Url().GET_AFFILIATE_SOCIAL_CHANNELS)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get social channels', ex.message);
                throw ex;
            });
    }

    updateMainChannel(data?) {
        return axios
            .post(Url().UPDATE_AFFILIATE_MAIN_CHANNEL, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to update social as main channel', ex.message);
                throw ex;
            });
    }

    disconnectSocialChannels(data?) {
        return axios
            .post(Url().DISCONNECT_AFFILIATE_SOCIAL_CHANNEL, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to disconnect social channels', ex.message);
                throw ex;
            });
    }

    acceptAgreement(data?) {
        return axios
            .post(Url().ACCEPT_AGREEMENT, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to accept agreement', ex.message);
                throw ex;
            });
    }

    closeAccount(data?) {
        return axios
            .post(Url().CLOSE_ACCOUNT, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to close account', ex.message);
                throw ex;
            });
    }

    getFinalPayout() {
        return axios
            .get(Url().GET_FINAL_PAYOUT)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get final payout AMOUNTS', ex.message);
                throw ex;
            });
    }

    updateOAuthChannel(data?) {
        return axios
            .post(Url().UPDATE_OAUTH_CHANNEL, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateOAuthChannel:', ex.message);
                throw ex;
            });
    }

    checkCodeAvailability(params?) {
        return axios
            .get(Url().GET_CODE_AVAILABILITY, {params})
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to checkCodeAvailability', ex.message);
                throw ex;
            });
    }
}

export default new InfluencerApi();
